import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'
import { compose, pure } from 'recompose'

import { AssessorReportBlock } from 'containers/sections/assessors'
import { ObservationsBlock } from 'containers/sections/observations'
import { RpState } from 'containers/forms/residential-projects'
import { Input, InputDate, Radio, RadioError, RadioGroup, Select, Textarea } from 'components/fields'
import { FloatingBar, FormButton } from 'components/misc'
import { Section } from 'components/layout'
import { ActivityDetailLoader } from 'components/loaders'
import { form } from 'helpers/decorators'
import { apiActions, apiAssessors, apiResidentialProjects } from 'helpers/decorators/api'
import { TasksResidentialProjectSignoffSingle, TasksResidentialProjectSingle } from 'components/sections/tasks'
import { ACTIVITY_CATEGORIES, RP_PROGRESS_STATES } from 'constants/enums'
import { mapActivitiesCategories } from 'redux/selectors/activities'
import { validate } from 'models/residential-projects'
import { connect } from 'react-redux'
import assessorsDropdownSelector from '../../../../redux/selectors/assessors/assessorsDropdownSelector'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'

const enhance = compose(
  pure,
  injectIntl,
  apiResidentialProjects({
    updateRpDetail: true,
    detail: true
  }),
  apiAssessors(),
  connect(({ api, auth }) => ({
    assessors: api.assessors,
    authOrgId: get(auth, 'organization.id'),
  })),
  apiActions(),
  form({
    initialProps: 'residentialProjects.detail',
    initialPropsMapper: props => {
      let initialData = { ...props }

      if (get(props, 'activityCategory.userDefined')) {
        initialData = {
          ...initialData,
          activityCategory: {
            ...initialData.activityCategory,
            id: ACTIVITY_CATEGORIES.other.id
          },
          otherName: get(initialData, 'activityCategory.name')
        }
      }

      return initialData
    },
    validate
  })
)

class ResidentialProject extends Component {
  static propTypes = {
    residentialProjects: PropTypes.object.isRequired,
    projectLocationTypes: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    values: PropTypes.object,
    intl: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    changeActivityAssessor: PropTypes.func.isRequired,
    onSignoffRequestResidentialProject: PropTypes.func.isRequired,
    updateResidentialProject: PropTypes.func.isRequired,
    setupResidentialProject: PropTypes.func.isRequired,
    approveResidentialProject: PropTypes.func.isRequired,
    returnApproveResidentialProject: PropTypes.func.isRequired,
    signoffResidentialProject: PropTypes.func.isRequired,
    returnSignoffResidentialProject: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    changeRpState: PropTypes.func.isRequired,
    isOffline: PropTypes.bool,
    isAssessorDetailMandatory: PropTypes.bool,
    titles: PropTypes.array,
    dropdownAssessors: PropTypes.list,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func,
    assessors: PropTypes.object,
    codeLists: PropTypes.object,
    orgId: PropTypes.number,
    award: PropTypes.object,
    getParticipantActions: PropTypes.func
  }

  static defaultProps = {
    data: {}
  }

  async componentDidMount() {
    const actionId = get(this.props, 'residentialProjects.detail.residentialProjectAssessmentActionId')

    const participantId = get(this.props, 'award.participant.id')

    await actionId && participantId && this.props.getParticipantActions('', `id=${actionId}`, participantId)
  }

  async componentWillReceiveProps (nextProps) {

    if(get(this.props, 'residentialProjects.detail.id') !== get(nextProps, 'residentialProjects.detail.id')){
      const actionId = get(nextProps, 'residentialProjects.detail.residentialProjectAssessmentActionId')

      const participantId = get(nextProps, 'award.participant.id')

      await actionId && participantId && nextProps.getParticipantActions('', `id=${actionId}`, participantId)
    }
  }

  async componentWillMount() {
    await this.handleUpdate({}, this.props)
  }

  async componentWillUpdate(newProps) {
    await this.handleUpdate(this.props, newProps)
  }

  getOrgId(props) {
    return get(props, 'orgId')
  }

  getSubCategory(props) {
    return get(props, 'values.activityCategory.id')
  }

  async handleUpdate(props, newProps) {
    const newOrgId = this.getOrgId(newProps)

    const newSubCategory = this.getSubCategory(newProps)

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(newProps, 'detail'))

    const orgIdChanged = (newOrgId !== this.getOrgId(props))

    const subCategoryChanged = (newSubCategory !== this.getSubCategory(props))

    const isAssessorManagementEnabledChanged = (isAssessorManagementEnabled !== isAssessorManagementEnabledForActivity(get(props, 'detail')))

    if ((orgIdChanged || subCategoryChanged || isAssessorManagementEnabledChanged)
      && isAssessorManagementEnabled && newSubCategory && newSubCategory !== ACTIVITY_CATEGORIES.other.id && newOrgId
    ) {
      this.props.onGetAvailableAssessorsForActivityCategory(newOrgId, newSubCategory)
    }
  }

  render() {
    const {
      activities,
      residentialProjects: { detail, loading },
      values,
      projectLocationTypes,
      handleSubmit,
      updateResidentialProject,
      setupResidentialProject,
      approveResidentialProject,
      returnApproveResidentialProject,
      signoffResidentialProject,
      returnSignoffResidentialProject,
      changeActivityAssessor,
      intl,
      isOffline,
      isAssessorDetailMandatory,
      codeLists,
      titles,
      assessors,
      actions,
      award
    } = this.props
    const parentId = get(values, 'activityCategory.parent.id')
    const inSetupMode =
      RP_PROGRESS_STATES.rpSetup.id === get(detail.state, 'value')
    const mappedActivities = mapActivitiesCategories(
      activities.list,
      parentId,
      intl.formatMessage({
        id: 'label.other',
        defaultMessage: 'Other'
      })
    )

    const dropdownAssessors = assessorsDropdownSelector(assessors, this.props)

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(detail)

    const rpApproval = (
      <TasksResidentialProjectSingle
        data={detail}
        modal={this.props.modal}
        approveModal={approveResidentialProject}
        returnModal={returnApproveResidentialProject}
        isAssessorManagementEnabled={isAssessorManagementEnabled}
        codeLists={codeLists}
      />
    )

    const rpSignoff = (
      <TasksResidentialProjectSignoffSingle
        data={detail}
        modal={this.props.modal}
        onSignoffRequestResidentialProject={
          this.props.onSignoffRequestResidentialProject
        }
        approveModal={signoffResidentialProject}
        returnModal={returnSignoffResidentialProject}
        isAssessorManagementEnabled={isAssessorManagementEnabled}
        codeLists={codeLists}
      />
    )

    if (isOffline) {
      return (
        <FormattedHTMLMessage
          id="activity.cannot_edit_activity_offline"
          defaultMessage="You cannot edit activity if Award is in offline mode"
        />
      )
    }

    const forbiddenRPStates = [
      RP_PROGRESS_STATES.rpInProgress.id,
      RP_PROGRESS_STATES.rpAssessorApproval.id,
      RP_PROGRESS_STATES.rpLeaderSignoff.id,
      RP_PROGRESS_STATES.rpOfficeSignoff.id,
      RP_PROGRESS_STATES.rpCeremonySignoff.id,
      RP_PROGRESS_STATES.rpComplete.id,
      RP_PROGRESS_STATES.rpInactive.id
    ]

    const assessorDetailMandatoryPermittedRPStates = [
      RP_PROGRESS_STATES.rpSetup.id,
      RP_PROGRESS_STATES.rpApproval.id
    ]

    let assessorList = assessorsDropdownSelector(assessors, this.props)

    const assessorId = get(detail, 'assessor.id')

    assessorList = assessorId && assessorList.filter(a => get(a, 'value') !== assessorId) || assessorList

    const showAssessorPanel = !isAssessorDetailMandatory || (isAssessorDetailMandatory && !assessorDetailMandatoryPermittedRPStates.includes(get(detail, 'state.value')))

    const subcategoryValue = get(values, 'activityCategory.id')

    const isOthersSubCategory = subcategoryValue === ACTIVITY_CATEGORIES.other.id

    const isAssessorSetup = get(values, 'setupAssessorId')

    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0 || assessorId === null

    const showAssessorForm = (!isAssessorManagementEnabled || (isNoneOfTheseSubCategory && subcategoryValue && !isAssessorSetup)) || isOthersSubCategory

    return (

      <Section loading={loading} contentLoader={<ActivityDetailLoader />}>
        <form
          onSubmit={handleSubmit(
            fields =>
              (inSetupMode
                ? setupResidentialProject(detail.id, fields)
                : updateResidentialProject(detail.id, fields))
          )}
        >
          {detail.id &&
            <RpState
              rpId={detail.id}
              rpState={detail.state}
              changeRpChange={this.props.changeRpState}
              rpApproval={rpApproval}
              rpSignoff={rpSignoff}
            />}

          <div>
            {detail.id && showAssessorPanel &&
              <AssessorReportBlock
                id={detail.id}
                data={detail}
                award={award}
                isAssessmentPositive={detail.isAssessmentPositive}
                assessmentActionId={detail.residentialProjectAssessmentActionId}
                actionId={detail.residentialProjectAssessmentActionId}
                changeAssessor={changeActivityAssessor}
                isResidentialProject
                state={get(detail, 'state')}
                isAssessorDetailMandatory={isAssessorDetailMandatory}
                isAssessorManagementEnabled={isAssessorManagementEnabled}
                assessorsList={assessorList}
                values={values}
                actions={actions.list}
              />}
          </div>
          <h2 className="base-margin--top">
            <FormattedMessage
              id="moduleTitle.activity_detail"
              defaultMessage="Activity detail"
            />
          </h2>

          <div className="row">
            <div className="col-xs-4">
              <Select
                label="Activity Type"
                intlKey="label.activity_type"
                name="activityCategory.parent.id"
                options={activities.parents
                  .filter(
                    item =>
                      get(item, 'activitySection.value') ===
                      get(detail, 'activitySection.value')
                  )
                  .map(item => ({
                    value: item.id,
                    label: item.translatedName
                  }))}
                searchable
              />
              <Select
                label="Activity"
                intlKey="label.activity"
                name="activityCategory.id"
                options={mappedActivities}
              />
              {isOthersSubCategory &&
                <Input
                  label="Other activity"
                  intlKey="label.other_activity"
                  name="otherName"
                />}
              <Textarea label="Goal" intlKey="label.goal" name="goal" />
              <InputDate
                label="Start date"
                intlKey="label.start_date"
                name="startDate"
              />
              <InputDate
                label="End date"
                intlKey="label.end_date"
                name="endDate"
              />
            </div>
            <div className="col-xs-4">
              <Input
                label="Location"
                intlKey="label.location"
                name="locationDetail"
              />
              <Textarea label="Note" intlKey="label.note" name="note" />
              <RadioGroup horizontal>
                {projectLocationTypes.list.map((item, index) => (
                  <Radio
                    justify
                    key={index}
                    label={item.label}
                    name="projectLocationType.value"
                    value={item.value}
                  />
                ))}
              </RadioGroup>
              <RadioError name="projectLocationType.value" />
            </div>
          </div>

          <ObservationsBlock
            observations={detail.observations}
            fileUrls={detail.fileUrls}
          />

          {(isAssessorDetailMandatory || isAssessorManagementEnabled) && !forbiddenRPStates.includes(get(detail, 'state.value')) && <div className="row">
            <div className="col-xs-4">
              <h2>
                <FormattedMessage
                    id="moduleTitle.assessor_details"
                    defaultMessage="Assessor Details"
                />
              </h2>
              {isAssessorManagementEnabled && <div>

                {!isOthersSubCategory && <div className="row">
                  <div className="col-xs-12">
                    <Select
                      name="setupAssessorId"
                      label=""
                      intlKey=""
                      options={dropdownAssessors}
                      disabled={!subcategoryValue || isOthersSubCategory}
                    />
                  </div>
                </div>}
              </div>}
              {showAssessorForm && <div>
                <Select
                  label="Title"
                  intlKey="label.title"
                  name="assessorTitle"
                  options={titles}
                />
                <Input label="Name" intlKey="label.name" name="assessorName" />
                <Input label="Email" intlKey="label.email" name="assessorEmail" />
                <Input label="Phone" intlKey="label.phone" name="assessorPhone" />
              </div>}
            </div>
          </div>}

          <div className="row">
            <div className="col-xs-12 text--right">
              <FloatingBar>
                <FormButton {...this.props}>
                  <FormattedMessage
                    id={inSetupMode ? 'button.setup' : 'button.save'}
                    defaultMessage={inSetupMode ? 'Setup' : 'Save'}
                  />
                </FormButton>
              </FloatingBar>
            </div>
          </div>
        </form>
      </Section>
    )
  }
}

export default enhance(ResidentialProject)
